import { useCallback } from 'react';
import { applications } from '../mockData';
import type { ApplicationDetails } from '../shared/types';

const useApplicationDetailsService = () => {
  const getApplication = useCallback(
    async (id: number): Promise<Nullable<ApplicationDetails>> =>
      applications.find(application => application.id === id) ?? null,
    [],
  );

  return { getApplication };
};

export default useApplicationDetailsService;
